const PaymentsTable = ({
    bulkSelect = false,
    payments = [],
    selectedItems = [],
    handleSelectAll = () => {},
    handleSelect = () => {},
    onEdit = () => {},
    onDelete = () => {}
}) => {

    return (
        <table className="mjsdev-table">
            <thead>
                <tr>
                    {bulkSelect &&
                        <th>
                            <input
                                type="checkbox"
                                onChange={handleSelectAll}
                                checked={
                                    payments.length > 0 &&
                                    selectedItems.length === payments.length
                                }
                            />
                        </th>
                    }
                    <th>Payment ID</th>
                    <th>Customer</th>
                    <th>Site Name</th>
                    <th>Amount($)</th>
                    <th>Payment Method</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th></th>
                </tr>
            </thead>

            {payments.length > 0 ? (
                <tbody>
                    {payments.map((payment) => (
                        <tr key={payment.id}>
                            {bulkSelect && 
                                <td>
                                    <input
                                        type="checkbox"
                                        onChange={() => handleSelect(payment.id)}
                                        checked={selectedItems.includes(payment.id)}
                                    />
                                </td>
                            }
                            <td>#{payment.payment_number || ""}</td>
                            <td>{payment.userName || "-"}</td>
                            <td>{payment.siteName || "-"}</td>
                            <td>{payment.amount || "--"}</td>
                            <td>{payment.methodDetail || "-"}</td>
                            <td>{payment.status || "-"}</td>
                            <td>
                                {payment.created
                                    ? new Date(payment.created * 1000).toDateString()
                                    : "—"}
                            </td>
                            <td className="mjsdev-table-actions">
                                <i
                                    onClick={() => onEdit(payment)}
                                    title="Edit Payment"
                                    className="fa-solid fa-edit"
                                />
                                <i
                                    onClick={() => onDelete(payment.id)}
                                    title="Delete Payment"
                                    className="fa-solid fa-trash"
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            ) : (
                <tbody>
                    <tr>
                        <td colSpan="8" className="mjsdev-msg">
                            No Payments found.
                        </td>
                    </tr>
                </tbody>
            )}
        </table>
    );
};

export default PaymentsTable;
